var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkOutBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5954 2.34766H11.2611L5.18031 8.42467L6.59541 9.83888L12.6762 3.76186V8.42469H14.6775V0.347656H6.5954V2.34766Z",
    fill: "#66C6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68 2.34766V4.34766H2.67874V12.3477H10.6838V10.3477H12.685V14.3477H0.67749V2.34766H4.68Z",
    fill: "#66C6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutBold);
export default __webpack_public_path__ + "static/media/link-out-bold.4e23ca3a0411ec3d3518d4ef237a6241.svg";
export { ForwardRef as ReactComponent };